export enum LoadingConfigurationsType {
  Loading = 'Loading',
  Error = 'Error',
  Loaded = 'Loaded',
}
